import { render, staticRenderFns } from "./iview.vue?vue&type=template&id=6b1c4d5a&scoped=true&"
import script from "./iview.vue?vue&type=script&lang=js&"
export * from "./iview.vue?vue&type=script&lang=js&"
import style0 from "./iview.vue?vue&type=style&index=0&id=6b1c4d5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c4d5a",
  null
  
)

export default component.exports